import { ReactElement } from 'react';
import { ButtonLeft, ButtonLinkLeft } from '@zoopla-eng/zds/button';

type DynamicPhoneNumberProps = {
    onClickToCall: () => void;
    onClickToReveal: () => void;
    children: string;
    Icon: (props: { color: 'currentColor' }) => ReactElement;
    buttonCategory?: 'primary' | 'secondary' | 'tertiary';
    phone?: string | null;
    disabled?: boolean;
    loading?: boolean;
    fw?: boolean;
};

export const DynamicPhoneNumber: React.FC<DynamicPhoneNumberProps> = ({
    onClickToCall,
    onClickToReveal,
    children,
    Icon,
    buttonCategory,
    phone,
    disabled,
    loading,
    fw
}) => {
    return phone ? (
        <ButtonLinkLeft
            fw={fw}
            href={phone ? `tel:${phone}` : ''}
            onClick={onClickToCall}
            category={buttonCategory ?? 'tertiary'}
            Icon={Icon}
            loading={loading ?? false}
            loadingText="loading"
            data-testid="agent-dynamic-phone-cta"
        >
            {children}
        </ButtonLinkLeft>
    ) : (
        <ButtonLeft
            fw={fw}
            onClick={onClickToReveal}
            category={buttonCategory ?? 'tertiary'}
            disabled={disabled}
            Icon={Icon}
            data-testid="agent-dynamic-phone-cta"
        >
            {children}
        </ButtonLeft>
    );
};
